export const CRYPTO_DELETE_REQUEST = 'CRYPTO_DELETE_REQUEST'
export const CRYPTO_DELETE_SUCCESS = 'CRYPTO_DELETE_SUCCESS'
export const CRYPTO_DELETE_FAIL = 'CRYPTO_DELETE_FAIL'
export const CRYPTO_DELETE_RESET = 'CRYPTO_DELETE_RESET'

export const STOCKS_DELETE_REQUEST = 'STOCKS_DELETE_REQUEST'
export const STOCKS_DELETE_SUCCESS = 'STOCKS_DELETE_SUCCESS'
export const STOCKS_DELETE_FAIL = 'STOCKS_DELETE_FAIL'
export const STOCKS_DELETE_RESET = 'STOCKS_DELETE_RESET'

export const TRANSACTIONS_DELETE_REQUEST = 'TRANSACTIONS_DELETE_REQUEST'
export const TRANSACTIONS_DELETE_SUCCESS = 'TRANSACTIONS_DELETE_SUCCESS'
export const TRANSACTIONS_DELETE_FAIL = 'TRANSACTIONS_DELETE_FAIL'
export const TRANSACTIONS_DELETE_RESET = 'TRANSACTIONS_DELETE_RESET'

export const TRADE_SUGGESTION_REQUEST = 'TRADE_SUGGESTION_REQUEST'
export const TRADE_SUGGESTION_SUCCESS = 'TRADE_SUGGESTION_SUCCESS'
export const TRADE_SUGGESTION_FAIL = 'TRADE_SUGGESTION_FAIL'
export const TRADE_SUGGESTION_RESET = 'TRADE_SUGGESTION_RESET'

